import { combineReducers } from 'redux';
// Import reducers
import table from './tags_panel_reducer';
import form from './tags_form_reducer';

export default combineReducers({
	table,
	form
});
